import React, { useState } from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { IconButton, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export const TextFormField = ({ field, form, label, backgroundColor, isRequired, bgcolor, border, placeholder, type, onChange, ...props }) => {
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((prev) => !prev);
	const handleMouseDownPassword = (event) => event.preventDefault();

	// Restrict Input for "name" Fields
	const handleChange = (e) => {
				let value = e.target.value;
				if (type === "name") {
					value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove numbers and special characters
				}
		form.setFieldValue(field.name, value);
		if(onChange){
			onChange(value)
		}
	};

	return (
		<FormControl fullWidth error={!!errorText}>
			{label && (
				<InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
					<Typography variant="body1" sx={{ textTransform: "capitalize", color: "text.secondary" }}>
						{label}
						{isRequired && (
							<Typography variant="body1" color="error" component="span">
								{" *"}
							</Typography>
						)}
					</Typography>
				</InputLabel>
			)}
			<TextField
				{...field}
				fullWidth
				id={field.name}
				placeholder={placeholder}
				type={type === "password" ? (showPassword ? "text" : "password") : type} // Correct toggle logic
				sx={{
					bgcolor: bgcolor,
					border: border || "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiInputBase-input": { padding: "10px 14px", backgroundColor: backgroundColor || "transparent" },
					...(type === "number" && {
						"& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
							display: "none",
							margin: 0,
						},
						"& input[type=number]": {
							"-moz-appearance": "textfield",
						},
					}),
				}}
				{...props}
				onChange={handleChange}
				onBlur={form.handleBlur}
				slotProps={{
					input: {
						endAdornment: type === "password" && (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge="end"
								>
									{showPassword ? <VisibilityIcon fontSize="20px" sx={{ color: "red.main" }} /> : <VisibilityOffIcon fontSize="20px" sx={{ color: "red.main" }} />}
								</IconButton>
							</InputAdornment>
						),
					}
				}}
			/>
			<Typography variant="body2" fontSize={"10px"} color="#DC143C">
				{errorText}
			</Typography>
		</FormControl>
	);
};
